var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCompositeSamples = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 6C1 8.7614 3.23857 11 6 11C8.7614 11 11 8.7614 11 6C11 3.23857 8.7614 1 6 1C3.23857 1 1 3.23857 1 6ZM10 6C10 8.20915 8.20915 10 6 10C3.79086 10 2 8.20915 2 6C2 3.79086 3.79086 2 6 2C8.20915 2 10 3.79086 10 6ZM9 6C9 7.65685 7.65685 9 6 9V3C7.65685 3 9 4.34315 9 6Z",
    fill: "#1B1F1E"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCompositeSamples, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/composite-samples.6e745746.svg";
export { ForwardRef as ReactComponent };